import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class MCPServer  {
    _originalTypeClassName = "zvelton_Backoffice.BO.MCPServer";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
MCPServer.translate = translateService;
}
this.Id = null;
this.Name = null;
this.URl = null;
this.Enabled = false;
this.Transport = null;
this.AuthType = null;
this.Auth_Basic_UserName = null;
this.Auth_Basic_Password = null;
this.Auth_ApiKey_Value = null;
this.Auth_ApiKey_Header = null;
this.Auth_ForwardHeader_Name = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
URl:any;
Enabled:any;
Transport:any;
AuthType:any;
Auth_Basic_UserName:any;
Auth_Basic_Password:any;
Auth_ApiKey_Value:any;
Auth_ApiKey_Header:any;
Auth_ForwardHeader_Name:any;


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}